<template>
  <b-modal
    id="modal-uploadImages"
    title="Upload all project images"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="white"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="login">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Put all images in a .zip format.">
                <b-form-file
                  v-model="form.file"
                  :state="Boolean(form.file)"
                  placeholder="Choose a file or drop it like it's hot here ..."
                  drop-placeholder="Drop it like it's hot here..."
                ></b-form-file>
                <div class="mt-3">
                  Selected file: {{ form.file ? form.file.name : "" }}
                </div>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-uploadImages')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Upload Images
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      isSending: false,
      uploadProgress: "",
      form: {
        file: null,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(percentCompleted);
        },
      };

      let projectId = this.$store.state.api.selectedProject.id;

      let formData = new FormData();
      formData.append("file", this.form.file);

      return new Promise((resolve, reject) => {
        axios(
          {
            url: `${this.$store.state.login.url}/api/dashboard/projects/${projectId}/images/upload`,
            data: formData,
            headers: {
              Authorization: `Bearer ${this.$store.state.login.token}`,
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
            },
            method: "POST",
          },
          config
        )
          .then((response) => {
            this.isSending = false;
            this.$bvModal.hide("modal-uploadImages");
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
            // TODO: REMOVE THIS FOR PRODUCTION
            setTimeout(() => {
              this.$router.go();
            }, 1000);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
